export const TYPES = {
  SET_SUPPORTER_SUCCESS: "supporter/SET_SUPPORTER_SUCCESS",
};
